<template>
    <div id="app">
        <MainMenubar />
        <a class="anchor" id="inicio"></a>
        <FotosTopo />
        <!-- <Carousel /> -->
        <div id="maincontainer">
            <Home />
        </div>
    </div>
</template>

<script>
import MainMenubar from './components/MainMenubar.vue'
// import Sidebar from './components/Sidebar.vue'
// import Carousel from './components/Carousel.vue'
import FotosTopo from './components/FotosTopo.vue'
import Home from './components/Home.vue'
// import Lipsum from './components/Lipsum.vue'

export default {
    name: 'App',
    components: {
        MainMenubar,
        // Sidebar,
        // Carousel,
        FotosTopo,
        Home,
    },
}
</script>

<style>
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
*/
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 52px;
}

.navbar-brand {
    font-size: 1.1rem !important;
}

#maincontainer {
    text-align: justify;
    padding: 10px;
}
</style>
